import { render, staticRenderFns } from "./new-connection-account-form.vue?vue&type=template&id=04500b01&"
import script from "./new-connection-account-form.vue?vue&type=script&lang=js&"
export * from "./new-connection-account-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports